import { type OrganizationList, isChurch } from 'models';
import { useCallback } from 'react';

export const useGetOrganizationTag = () =>
  useCallback(
    ({ organization }: { organization: OrganizationList }) => (isChurch({ organization }) ? 'Church' : 'Organization'),
    [],
  );
